/**
 * AppSidebar — persistente Navigation auf Tablet/Desktop (ab md).
 * Zeigt ALLE rollen-relevanten Ziele + Konto-Menü am Fuß. Auf Mobil ausgeblendet
 * (dort übernimmt MobileNav). Ersetzt das frühere „nur über Start erreichbar".
 */
import { useLocation } from 'react-router-dom';
import { useNavigateGeschuetzt } from '@/hooks/useVerlassenWarnung';
import { useAuth } from '@/context/AuthContext';
import { NAV_ITEMS, filterNavByRole, filterNavByRechte, isNavActive } from '@/config/navigation';
import { useZugang } from '@/hooks/useZugang';
import { AccountMenu } from '@/components/AccountMenu';

export function AppSidebar() {
  const location = useLocation();
  const navigate = useNavigateGeschuetzt();
  const { user } = useAuth();
  const { rechte, geladen, laedt, fachbereich } = useZugang();
  const items = filterNavByRechte(filterNavByRole(NAV_ITEMS, user?.role), rechte, geladen, fachbereich);

  return (
    <aside className="hidden md:flex fixed inset-y-0 left-0 w-64 flex-col bg-card border-r border-border z-40">
      <div className="brand-stripe" />
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-4 border-b border-border">
        <div className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center overflow-hidden flex-shrink-0">
          <img src="/logo.png" alt="Ludwig Zimmermann" className="w-full h-full object-contain p-1" />
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-sm truncate">Zimmermann</div>
          <div className="text-[11px] text-muted-foreground truncate">Monteur-App</div>
        </div>
      </div>

      {/* Nav */}
      {/* Solange die Rechte noch unterwegs sind, wird nicht geraten: ein
          ruhiger Platzhalter statt aller Ziele, die gleich wieder
          verschwinden. Schlaegt das Laden fehl, zeigt `items` wie bisher
          alles — ein Netzausfall sperrt niemanden aus. */}
      <nav className="flex-1 overflow-y-auto p-2 space-y-1" aria-busy={laedt}>
        {laedt
          ? Array.from({ length: 6 }, (_, i) => (
              <div key={i} className="h-10 rounded-lg bg-muted animate-pulse" aria-hidden />
            ))
          : items.map((item) => {
              const active = isNavActive(location.pathname, item.path);
              const Icon = item.icon;
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                    active
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground/80 hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="truncate">{item.label}</span>
                </button>
              );
            })}
      </nav>

      {/* Konto */}
      <div className="border-t border-border p-2">
        <AccountMenu variant="full" />
      </div>
    </aside>
  );
}
